import React, { createContext, useContext, useState, useCallback } from "react";
import { X, Phone } from "lucide-react";
import { BRAND } from "../mock";
import OpenTableWidget from "./OpenTableWidget";

const ReservationContext = createContext(null);

export function useReservation() {
  const ctx = useContext(ReservationContext);
  if (!ctx) return { open: () => {}, close: () => {} };
  return ctx;
}

export function ReservationProvider({ children }) {
  const [open, setOpen] = useState(false);

  const openModal = useCallback(() => {
    setOpen(true);
    document.body.style.overflow = "hidden";
  }, []);
  const closeModal = useCallback(() => {
    setOpen(false);
    document.body.style.overflow = "";
  }, []);

  return (
    <ReservationContext.Provider value={{ open: openModal, close: closeModal }}>
      {children}
      {open && <ReservationModal onClose={closeModal} />}
    </ReservationContext.Provider>
  );
}

function ReservationModal({ onClose }) {
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-6">
      <div className="absolute inset-0 bg-nala-black/85 backdrop-blur-sm" onClick={onClose} />

      <div className="relative w-full max-w-lg bg-nala-cream shadow-2xl max-h-[94vh] overflow-hidden flex flex-col animate-[fadeUp_0.4s_cubic-bezier(0.22,1,0.36,1)] border border-nala-gold/40">
        {/* Header */}
        <div className="flex items-center justify-between px-6 md:px-8 py-5 bg-gradient-to-r from-nala-maroon-dark to-nala-maroon">
          <div className="flex items-center gap-3">
            <img src={BRAND.logos.gold} alt="Nala" className="h-9 w-auto" />
            <div>
              <p className="font-display text-nala-cream text-sm tracking-wide-lux uppercase leading-none">Reserve a Table</p>
              <p className="text-nala-gold-light text-xs mt-1">Powered by OpenTable</p>
            </div>
          </div>
          <button onClick={onClose} aria-label="Close" className="w-9 h-9 rounded-full border border-nala-gold/50 flex items-center justify-center text-nala-gold hover:bg-nala-gold hover:text-nala-maroon-dark transition-all">
            <X size={18} />
          </button>
        </div>

        {/* Body — OpenTable widget */}
        <div className="flex-1 overflow-y-auto p-5 md:p-6">
          <OpenTableWidget height={480} />
        </div>

        {/* Footer */}
        <div className="px-6 md:px-8 py-3.5 border-t border-nala-gold/30 flex items-center justify-center gap-2 bg-nala-cream">
          <Phone size={14} className="text-nala-maroon" />
          <a href={BRAND.phoneHref} className="text-nala-maroon text-sm hover:text-nala-maroon-light transition-colors tracking-wide-lux">{BRAND.phone}</a>
        </div>
      </div>
    </div>
  );
}
